import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoading: false,
  planCarrera: null,
  planCarreraError: "",
  formError: "",
  loadingInfoEncabezado: "",
  infoEncabezado: ""
}

export default function PlanCarreraReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_PLAN_CARRERA:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_PLAN_CARRERA:
      return { ...state, saveLoading: action.payload };
    case actions.GET_PLAN_CARRERA:
      return {
        ...state,
        planCarrera: action.payload.planCarrera,
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.PLAN_CARRERA_FAIL:
      return { ...state, planCarreraError: action.payload };

    //información del encabezado (empleado y funcion)
    case actions.LOADING_INFO_ENCABEZADO:
      return { ...state, loadingInfoEncabezado: action.payload };
    case actions.GET_INFO_ENCABEZADO:
      return {
        ...state,
        infoEncabezado: action.payload.infoEncabezado,
      };


    default:
      return state;
  }
}